// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Inter, sans-serif;
    font-size: 18px;
    margin: 0;
    padding: 0;
}

.header-container {
    display: flex;
    flex-direction: row;
    width: 1512px;
    height: 890px;
    margin: 0 auto;
}

.header-container .header-left-section {
    padding-bottom: 20px;
    margin: 0;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.header-container .header-left-section .box {
    margin-top: 247px;
    margin-left: 68px;
    position: relative;
    margin-right: 0px;
    height: 310px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.header-container .header-left-section .image {
    position: absolute;
    top: 74px;
    left: 267px;
    width: 509px;
    height: 501.67px;
    border-radius: 481px;
}

.header-container .header-left-section .box h1 {
    color: var(--black, #000);
    font-family: Georgia;
    font-size: 58px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
}

.header-container .header-left-section .highlight {
    color: var(--blue, #458BEA);
    font-family: Georgia;
    font-size: 58px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
}

.header-container .header-left-section .box .text {
    align-self: stretch;
    color: var(--semantic-text-primary);
    font-family: var(--p-font-family);
    font-size: var(--p-font-size);
    font-style: var(--p-font-style);
    font-weight: var(--p-font-weight);
    letter-spacing: var(--p-letter-spacing);
    line-height: var(--p-line-height);
    position: relative;
    
}

.header-container .button-container {
    position: relative;
    top: 5px;
    margin-left: 0px;
    justify-content: left;
}

.header-left-section .button-instance {}

.header-container .right-section {
    display: grid;
    grid-template-columns: 466px 466px;
    grid-template-rows: 300px 552px;
    gap: 10px;
    width: 943.998px;
    height: 864px;
    margin-left: auto;
}

.image-block {
    position: relative;
    width: 100%;
    height: 100%;
    perspective: 1000px;
    text-decoration: none;
}

.card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    transform-style: preserve-3d;
}

.image-block.flipped .card-inner {
    transform: rotateY(180deg);
}

.card-front,
.card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    overflow: hidden;
}

.card-front {
    z-index: 2;
}

.card-back {
    transform: rotateY(180deg);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1a1a1a;
}

/* Color transitions */
.card-front::before,
.card-back::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 0.3s ease;
    pointer-events: none;
    z-index: 1;
}

/* Front side colors */
.image-block.blue .card-front::before {
    background: rgba(69, 139, 234, 0.50);
}

.image-block.red .card-front::before {
    background: rgba(212, 31, 67, 0.61);
}

/* Back side colors (opposite of front) */
.image-block.blue .card-back::before {
    background: rgba(212, 31, 67, 0.61);
}

.image-block.red .card-back::before {
    background: rgba(69, 139, 234, 0.50);
}

.image-block1::before,
.image-block2::before,
.image-block3::before,
.image-block4::before {
    display: none;
}

.image-block1 {
    width: 100%;
    height: 300px;
    margin-top: 12px;
}

.image-block2 {
    width: 100%;
    height: 424px;
    margin-top: 12px;
}

.image-block3 {
    width: 100%;
    height: 552px;
    margin-top: 12px;
}

.image-block4 {
    width: 100%;
    height: 428px;
    margin-top: 136px;
}

.image-content {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    z-index: 0;
}

.preview-content {
    padding: 20px;
    color: white;
    text-align: left;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: relative;
    z-index: 2;
}

.preview-image {
    width: 100%;
    height: 60%;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.preview-text {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.preview-text h2 {
    font-size: 24px;
    margin: 0;
    font-family: Georgia;
    color: white;
}

.preview-text p {
    font-size: 16px;
    margin: 0;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.9);
}

.header-container .mobile-image {
    display: none;
}


/* Media query for mobile view */
@media (max-width: 1224px) {
    .header-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        padding: 0 15px;
        height: auto;
    }

    .header-container .mobile-image,
    .header-container .mobile-image2 {
        display: block;
        width: 100%; /* Ensure both images take full width */
        height: 300px; /* Maintain the same height */
        position: relative;
        margin-bottom: 0px; /* Add some space between images */
        margin-top: 20px; /* Add some space between images */
    }

    .header-container .mobile-image img,
    .header-container .mobile-image2 img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
    }

    .header-container .mobile-image::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(69, 139, 234, 0.50); /* Blue overlay */
        z-index: 1;
    }

    .header-container .mobile-image2::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(212, 31, 67, 0.61); /* Red overlay */
        z-index: 1;
    }

    .header-container .header-left-section {
        order: 2;
        height: auto;
        display: flex;
        padding: 23.387px 22.933px 0px 0px;
        margin-left: 0px;
        margin-right: 0px;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }

    .header-container .header-left-section .box {
        display: flex;
        height: auto;
        flex-direction: column;
        align-items: flex-start;
        gap: 9.173px;
        align-self: center;
        margin: 0px;
        text-align: left;
    }

    .header-container .header-left-section .box .text {
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        width: 100%;
        height: auto;
    }

    .header-container .button-container {
        margin-bottom: 20px;
        display: flex;
        justify-content: left;
        width: 100%;
    }

    .header-container .header-left-section .image {
        display: none;
    }

    .header-container .right-section,
    .header-container .image-block1,
    .header-container .image-block2,
    .header-container .image-block3,
    .header-container .image-block4 {
        display: none;
    }
}

@media (max-width: 400px) {
    .header-container .header-left-section .box .text {
        font-size: 14px;
        line-height: 20px;
        width: 100%;
    }
}

/* Add a subtle hover effect to the preview image */
.preview-image {
    transition: transform 0.3s ease;
}

.preview-image:hover {
    transform: scale(1.02);
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/style.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,iCAAiC;IACjC,6BAA6B;IAC7B,+BAA+B;IAC/B,iCAAiC;IACjC,uCAAuC;IACvC,iCAAiC;IACjC,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,uCAAuC;;AAEvC;IACI,aAAa;IACb,kCAAkC;IAClC,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uDAAuD;IACvD,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,oBAAoB;IACpB,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,yCAAyC;AACzC;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;;AAGA,gCAAgC;AAChC;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,mBAAmB;QACnB,eAAe;QACf,YAAY;IAChB;;IAEA;;QAEI,cAAc;QACd,WAAW,EAAE,uCAAuC;QACpD,aAAa,EAAE,6BAA6B;QAC5C,kBAAkB;QAClB,kBAAkB,EAAE,kCAAkC;QACtD,gBAAgB,EAAE,kCAAkC;IACxD;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,oCAAoC,EAAE,iBAAiB;QACvD,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,mCAAmC,EAAE,gBAAgB;QACrD,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,YAAY;QACZ,aAAa;QACb,kCAAkC;QAClC,gBAAgB;QAChB,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;;;;;QAKI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;IACf;AACJ;;AAEA,mDAAmD;AACnD;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["body {\n    font-family: Inter, sans-serif;\n    font-size: 18px;\n    margin: 0;\n    padding: 0;\n}\n\n.header-container {\n    display: flex;\n    flex-direction: row;\n    width: 1512px;\n    height: 890px;\n    margin: 0 auto;\n}\n\n.header-container .header-left-section {\n    padding-bottom: 20px;\n    margin: 0;\n    width: 500px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.header-container .header-left-section .box {\n    margin-top: 247px;\n    margin-left: 68px;\n    position: relative;\n    margin-right: 0px;\n    height: 310px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.header-container .header-left-section .image {\n    position: absolute;\n    top: 74px;\n    left: 267px;\n    width: 509px;\n    height: 501.67px;\n    border-radius: 481px;\n}\n\n.header-container .header-left-section .box h1 {\n    color: var(--black, #000);\n    font-family: Georgia;\n    font-size: 58px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%;\n}\n\n.header-container .header-left-section .highlight {\n    color: var(--blue, #458BEA);\n    font-family: Georgia;\n    font-size: 58px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%;\n}\n\n.header-container .header-left-section .box .text {\n    align-self: stretch;\n    color: var(--semantic-text-primary);\n    font-family: var(--p-font-family);\n    font-size: var(--p-font-size);\n    font-style: var(--p-font-style);\n    font-weight: var(--p-font-weight);\n    letter-spacing: var(--p-letter-spacing);\n    line-height: var(--p-line-height);\n    position: relative;\n    \n}\n\n.header-container .button-container {\n    position: relative;\n    top: 5px;\n    margin-left: 0px;\n    justify-content: left;\n}\n\n.header-left-section .button-instance {}\n\n.header-container .right-section {\n    display: grid;\n    grid-template-columns: 466px 466px;\n    grid-template-rows: 300px 552px;\n    gap: 10px;\n    width: 943.998px;\n    height: 864px;\n    margin-left: auto;\n}\n\n.image-block {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    perspective: 1000px;\n    text-decoration: none;\n}\n\n.card-inner {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n    transform-style: preserve-3d;\n}\n\n.image-block.flipped .card-inner {\n    transform: rotateY(180deg);\n}\n\n.card-front,\n.card-back {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    overflow: hidden;\n}\n\n.card-front {\n    z-index: 2;\n}\n\n.card-back {\n    transform: rotateY(180deg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #1a1a1a;\n}\n\n/* Color transitions */\n.card-front::before,\n.card-back::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transition: background-color 0.3s ease;\n    pointer-events: none;\n    z-index: 1;\n}\n\n/* Front side colors */\n.image-block.blue .card-front::before {\n    background: rgba(69, 139, 234, 0.50);\n}\n\n.image-block.red .card-front::before {\n    background: rgba(212, 31, 67, 0.61);\n}\n\n/* Back side colors (opposite of front) */\n.image-block.blue .card-back::before {\n    background: rgba(212, 31, 67, 0.61);\n}\n\n.image-block.red .card-back::before {\n    background: rgba(69, 139, 234, 0.50);\n}\n\n.image-block1::before,\n.image-block2::before,\n.image-block3::before,\n.image-block4::before {\n    display: none;\n}\n\n.image-block1 {\n    width: 100%;\n    height: 300px;\n    margin-top: 12px;\n}\n\n.image-block2 {\n    width: 100%;\n    height: 424px;\n    margin-top: 12px;\n}\n\n.image-block3 {\n    width: 100%;\n    height: 552px;\n    margin-top: 12px;\n}\n\n.image-block4 {\n    width: 100%;\n    height: 428px;\n    margin-top: 136px;\n}\n\n.image-content {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    position: relative;\n    z-index: 0;\n}\n\n.preview-content {\n    padding: 20px;\n    color: white;\n    text-align: left;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    position: relative;\n    z-index: 2;\n}\n\n.preview-image {\n    width: 100%;\n    height: 60%;\n    object-fit: cover;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.preview-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.preview-text h2 {\n    font-size: 24px;\n    margin: 0;\n    font-family: Georgia;\n    color: white;\n}\n\n.preview-text p {\n    font-size: 16px;\n    margin: 0;\n    line-height: 1.4;\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.header-container .mobile-image {\n    display: none;\n}\n\n\n/* Media query for mobile view */\n@media (max-width: 1224px) {\n    .header-container {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        align-items: center;\n        padding: 0 15px;\n        height: auto;\n    }\n\n    .header-container .mobile-image,\n    .header-container .mobile-image2 {\n        display: block;\n        width: 100%; /* Ensure both images take full width */\n        height: 300px; /* Maintain the same height */\n        position: relative;\n        margin-bottom: 0px; /* Add some space between images */\n        margin-top: 20px; /* Add some space between images */\n    }\n\n    .header-container .mobile-image img,\n    .header-container .mobile-image2 img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        position: relative;\n    }\n\n    .header-container .mobile-image::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(69, 139, 234, 0.50); /* Blue overlay */\n        z-index: 1;\n    }\n\n    .header-container .mobile-image2::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(212, 31, 67, 0.61); /* Red overlay */\n        z-index: 1;\n    }\n\n    .header-container .header-left-section {\n        order: 2;\n        height: auto;\n        display: flex;\n        padding: 23.387px 22.933px 0px 0px;\n        margin-left: 0px;\n        margin-right: 0px;\n        justify-content: flex-start;\n        align-items: center;\n        width: 100%;\n    }\n\n    .header-container .header-left-section .box {\n        display: flex;\n        height: auto;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 9.173px;\n        align-self: center;\n        margin: 0px;\n        text-align: left;\n    }\n\n    .header-container .header-left-section .box .text {\n        text-align: left;\n        font-size: 16px;\n        line-height: 24px;\n        width: 100%;\n        height: auto;\n    }\n\n    .header-container .button-container {\n        margin-bottom: 20px;\n        display: flex;\n        justify-content: left;\n        width: 100%;\n    }\n\n    .header-container .header-left-section .image {\n        display: none;\n    }\n\n    .header-container .right-section,\n    .header-container .image-block1,\n    .header-container .image-block2,\n    .header-container .image-block3,\n    .header-container .image-block4 {\n        display: none;\n    }\n}\n\n@media (max-width: 400px) {\n    .header-container .header-left-section .box .text {\n        font-size: 14px;\n        line-height: 20px;\n        width: 100%;\n    }\n}\n\n/* Add a subtle hover effect to the preview image */\n.preview-image {\n    transition: transform 0.3s ease;\n}\n\n.preview-image:hover {\n    transform: scale(1.02);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
